import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-rdr-dark text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img
              src="https://images.squarespace-cdn.com/content/v1/5ff52abbfe6e8d5e4781b57a/1609977666561-KA61GJFJSQ1HY463YCNR/Red-Door-Ranch-Horizontal+White.png"
              alt="Red Door Ranch"
              className="h-12 w-auto object-contain mb-6"
            />
            <p className="text-white/60 text-sm leading-relaxed max-w-sm font-sans">
              A 20-acre hilltop luxury wedding and event destination in Joshua, TX.
              Where unforgettable events become timeless experiences.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://www.facebook.com/RedDoorRanchVenue"
                target="_blank"
                rel="nofollow noreferrer"
                aria-label="Facebook"
                className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-sm hover:border-rdr-gold hover:text-rdr-gold text-white/60 transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg" />
              </a>
              <a
                href="https://www.instagram.com/reddoorranchvenue"
                target="_blank"
                rel="nofollow noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-sm hover:border-rdr-gold hover:text-rdr-gold text-white/60 transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-lg" />
              </a>
              <a
                href="https://www.pinterest.com/RedDoorRanchVenue/"
                target="_blank"
                rel="nofollow noreferrer"
                aria-label="Pinterest"
                className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-sm hover:border-rdr-gold hover:text-rdr-gold text-white/60 transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-pinterest-line text-lg" />
              </a>
              <a
                href="mailto:reddoorranchtx@gmail.com"
                aria-label="Email"
                className="w-10 h-10 flex items-center justify-center border border-white/20 rounded-sm hover:border-rdr-gold hover:text-rdr-gold text-white/60 transition-colors duration-300 cursor-pointer"
              >
                <i className="ri-mail-line text-lg" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 id="footer-nav" className="text-rdr-gold text-xs tracking-widest uppercase font-sans font-medium mb-6">
              <a href="#footer-nav">Navigate</a>
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Home', path: '/' },
                { label: 'Services', path: '/services' },
                { label: 'About Us', path: '/about' },
                { label: 'Location', path: '/location' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/60 text-sm hover:text-rdr-gold transition-colors duration-300 font-sans"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 id="footer-contact" className="text-rdr-gold text-xs tracking-widest uppercase font-sans font-medium mb-6">
              <a href="#footer-contact">Contact</a>
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="https://www.google.com/maps/dir//5801+County+Rd+915,+Joshua,+TX+76058"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="text-white/60 text-sm hover:text-rdr-gold transition-colors duration-300 font-sans leading-relaxed cursor-pointer"
                >
                  5801 County Road 915<br />Joshua, TX 76058
                </a>
              </li>
              <li>
                <a
                  href="tel:+18175048501"
                  className="text-white/60 text-sm hover:text-rdr-gold transition-colors duration-300 font-sans cursor-pointer"
                >
                  (817) 504-8501
                </a>
              </li>
              <li>
                <a
                  href="mailto:reddoorranchtx@gmail.com"
                  className="text-white/60 text-sm hover:text-rdr-gold transition-colors duration-300 font-sans cursor-pointer"
                >
                  reddoorranchtx@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Scripture Quote */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 text-center">
          <p className="text-white/30 text-xs font-serif italic leading-relaxed max-w-2xl mx-auto">
            &ldquo;Love is patient, love is kind. It always protects, always trusts, always hopes, always perseveres. Love never fails.&rdquo; — 1 Corinthians 13:4-8
          </p>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-white/30 text-xs font-sans">
            &copy; {new Date().getFullYear()} Red Door Ranch. All rights reserved.
          </p>
          <p className="text-white/20 text-xs font-sans">
            Joshua, TX | Fort Worth Wedding Venue
          </p>
        </div>
      </div>
    </footer>
  );
}
